import React from 'react';

import { TagAvailableOnEnum } from '@/types/schema';

import { TagInputProps } from '../../../../modules/corporate/modules/tags/types';
import AttachTags from '../AttachTags';

interface ContentTagsProps {
  tag: TagInputProps;
  error: any;
  setFieldValue: any;
  availableOn?: TagAvailableOnEnum[];
  subWorkspaceIds?: string[];
  readonly?: boolean;
}

const DEFAULT_TAGS_AVAILABLE_ON = [TagAvailableOnEnum.Content];

const ContentTags: React.FC<ContentTagsProps> = (props) => {
  const {
    tag,
    error,
    setFieldValue,
    availableOn = DEFAULT_TAGS_AVAILABLE_ON,
    subWorkspaceIds,
    readonly,
  } = props;

  return (
    <AttachTags
      availableOn={availableOn}
      error={error}
      readonly={readonly}
      setFieldValue={setFieldValue}
      subWorkspaceIds={subWorkspaceIds}
      value={tag}
    />
  );
};

export default React.memo(ContentTags);
